
<div class="contentful__loader" *ngIf="isLoading">
  <div class=" loader loader--no-delay"></div>
</div>
<template #component></template>